module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "poll-add-choice",
    attrs: {
      "id": "add-choice"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addChoiceDisp),
      expression: "addChoiceDisp"
    }],
    on: {
      "click": function($event) {
        _vm.toggleAddChoiceDisp()
      }
    }
  }, [_c('div', {
    staticClass: "addchoice dash-border-color-skin"
  }, [_c('div', {
    staticClass: "dash-color-skin text-add-choice"
  }, [_vm._v(" " + _vm._s(_vm.labels[_vm.nowLang].pollAddChoice))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.addChoiceDisp),
      expression: "!addChoiceDisp"
    }]
  }, [_c('div', {
    staticClass: "dash-bg-color-skin-light-30 box-add-choice-fn"
  }, [(!_vm.hasImage) ? [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.addText),
      expression: "addText"
    }],
    staticClass: "form-control dash-border-color-skin",
    class: {
      'input-error': _vm.errors.has('addText')
    },
    attrs: {
      "name": "addText",
      "placeholder": "Choice Detail",
      "autocomplete": "off",
      "spellcheck": "false",
      "autocorrect": "off",
      "tabindex": "1"
    },
    domProps: {
      "value": (_vm.addText)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.addChoice()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addText = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('addText')),
      expression: "errors.has('addText')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('addText')))])] : [_c('div', {
    staticClass: "clearfix choice"
  }, [(_vm.activeDropzone) ? _c('div', {
    staticClass: "btn-add-pic"
  }, [_c('hrms-dropzone', {
    ref: "hrmsDropzone",
    attrs: {
      "flgRename": false,
      "othPath": _vm.filePath.save,
      "acceptedFileTypes": 'image/*'
    },
    model: {
      value: (_vm.namImage),
      callback: function($$v) {
        _vm.namImage = $$v
      },
      expression: "namImage"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "setup-margin-input"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.addText),
      expression: "addText"
    }],
    staticClass: "dash-border-color-skin input-poll-choice",
    class: {
      'input-error': _vm.errors.has('addText')
    },
    attrs: {
      "type": "text",
      "name": "addText",
      "placeholder": _vm.labels[_vm.nowLang].choicePlaceHolder
    },
    domProps: {
      "value": (_vm.addText)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.addChoice()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addText = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('addText')),
      expression: "errors.has('addText')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('addText')))])])])], _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4 btn-add-choice1 dash-bg-color-skin-dark-20",
    on: {
      "click": function($event) {
        _vm.addChoice()
      }
    }
  }, [_vm._v(_vm._s(_vm.labels[_vm.nowLang].confirm))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 btn-add-choice2 dash-bg-color-skin-dark-20",
    on: {
      "click": function($event) {
        _vm.cancelChoice()
      }
    }
  }, [_vm._v(_vm._s(_vm.labels[_vm.nowLang].cancel))])])], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5d438f49!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/poll/addChoice.vue
// module id = 3803
// module chunks = 1